import { Site } from '../modules/common/model';

export const MinWarningDuration: Record<Site.Kind, number> = {
  [Site.Kind.Airport]: 45,
  [Site.Kind.Station]: 30,
};

export const promotionDisplayRules = {
  minPromotionAmount: 3,
  minPromotionCoeff: 0.04,
};
